/**
 * textures.js - Texture Loading
 */
import * as THREE from "three";
import { TGALoader } from "three/examples/jsm/loaders/TGALoader";
import { TEXTURE_PATHS } from "./settings.js";

// Loading Manager
const manager = new THREE.LoadingManager();
const textureLoader = new TGALoader(manager);

// Geladene Texturen
export const textures = {};

// Aktuelle Textur
export let currentTextureName = "ObsidianGlass";

// Loading Callbacks
manager.onStart = (url, itemsLoaded, itemsTotal) => {
  console.log(`Loading: ${url} (${itemsLoaded}/${itemsTotal})`);
};

/**
 * Lädt alle Texturen und ruft callback auf wenn fertig
 */
export function loadAllTextures(onComplete) {
  manager.onLoad = () => {
    console.log("All resources loaded.");
    if (onComplete) onComplete();
  };

  // Texturen laden
  for (const materialName in TEXTURE_PATHS) {
    textures[materialName] = {};
    for (const textureType in TEXTURE_PATHS[materialName]) {
      textures[materialName][textureType] = textureLoader.load(
        TEXTURE_PATHS[materialName][textureType]
      );
    }
  }
}
